import {TabsComponent, PageHeader} from '@/components/molecules'
import {Breadcrumb} from '@/components/atoms'
import {OrderItemTab} from '@/containers'
import {useItemOverview} from '@/hooks/useItemOverview'

export const OrderItemOverview = () => {
  const {itemOverviewData, subItemColConfigData} = useItemOverview()

  const {generalDetails, deliveryAndStausInfo, subItemList, transactionDetails, discountInformation} =
    itemOverviewData || {}

  const tabList = [
    {
      id: 'orderItem',
      tabLabel: 'Order Item',
      tabComponent: (
        <OrderItemTab
          orderItemTabData={{
            generalDetails,
            deliveryAndStausInfo,
            subItemList,
            transactionDetails,
            subItemColConfigData,
            discountInformation,
          }}
        />
      ),
    },
    {
      id: 'priceInformation',
      tabLabel: 'Price Information',
      tabComponent: <div>Price Information tab content</div>,
    },
  ]
  const breadcrumbs = [
    {
      href: '/',
      label: '',
    },
    {
      href: '#',
      label: 'Online Order',
    },
    {
      href: '#',
      label: '2345652557',
    },
    {
      href: '',
      label: 'FLORENTINAS 66GRX9X7 FU',
    },
  ]

  return (
    <div className="orderItemOverview">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs,
        }}
        id="itemOverviewBreadcrumb"
      />
      <div className="flex flex-row justify-between">
        <PageHeader title="FLORENTINAS 66GRX9X7 FU" />
      </div>
      <TabsComponent tabList={tabList} defaultabIndex={0} />
    </div>
  )
}
